import { createSlice, current } from '@reduxjs/toolkit';
const ONDAY = 1000 * 60 * 60
const initialState = {
    focmode:undefined,
    notesList: [],
    noteFlag: false,
    canvasObj: "",
    x: "",
    y: '',
    newNote: false,
    selectedNote: "",
    popupShown: false,
    newPopup: false,
    noteText: "",
    lastNoteRef: "",
    notePreview: null,
    notesupdated:false
}
const notesCleanup = function () {
    Object.entries(localStorage).filter(x => {
        if (x[0].indexOf("LC#") == 0 || x[0].indexOf("notes#") == 0) {
            if ((Date.now() - JSON.parse(localStorage.getItem(x[0])).date) > ONDAY) {
                console.log(x[0])
                localStorage.removeItem(x[0])
            }
        }
    })
}
const noteSlice = createSlice({
    name: 'noteState',
    initialState,
    reducers: {
        changeXY: (state, { payload }) => {
            if (state.noteFlag) {
                state.x = payload.x
                state.y = payload.y
                state.newNote = true
            }
        },
        // updateXY:(state,{payload})=>{
        //     var currState = current(state);
        //     if(state.focmode == FOCPREVIEW && state.notePreview!= null)
        //     {
        //         var dragnote = state.notesList.findIndex((x,i) => x.name == state.notePreview)
        //         state.notesList[dragnote].x=payload.x
        //         state.notesList[dragnote].y=payload.y
        //     }
        // },
        setFOCMode(state,{payload}){
            state.focmode = payload
        },
        addNote(state, { payload }) {
            // if (state.noteFlag) {
            var name = new Date().valueOf().toString(36);
            var text = "";
            // state.notesList.push({ name: name, x: state.x, y: state.y, text: text })
            state.notesList = [...state.notesList, { name: name, x: state.x, y: state.y, text: text }]
            state.newNote = false
            state.noteFlag = false
            state.lastNoteRef = name
            state.notesupdated = true 
        },
        enableNote(state) {
            state.noteFlag = true
        },
        disableNote(state){
            state.noteFlag = false
        },
        showPopup(state, { payload }) {
            if(state.focmode)
            return
            var { popupShown, name, newPopup } = payload
            state.popupShown = popupShown
            state.selectedNote = state.notesList.filter((x) => x.name == name)[0]
            state.noteText = state.selectedNote.text
            state.newPopup = newPopup || false
            console.log(current(state))
        },
        updateNote(state) { // also closes the popup 
            var currState = current(state);
            var note = state.notesList.filter((x) => {
                return x.name == currState.selectedNote.name
            })[0]
            state.notesList = state.notesList.filter((x) => x.name !== currState.selectedNote.name)
            note.text = state.noteText
            state.notesList = [...state.notesList, note]
            state.selectedNote = ""
            state.popupShown = false
            state.noteText = ""
            state.lastNoteRef = ""
            state.notesupdated = true
            var targetBtn;
            var SelectedNoteName = currState.selectedNote.name;
            targetBtn = document.getElementsByName(SelectedNoteName)[0].focus();
        },
        deleteNote(state) {
            var currState = current(state);
            state.notesList = state.notesList.filter((x) => x.name !== currState.selectedNote.name)
            state.selectedNote = ""
            state.popupShown = false
            state.noteText = ""
            console.log(current(state))
            state.notesupdated = true
        },
        changeText(state, { payload }) {
            state.noteText = payload
            console.log(current(state))
            state.notesupdated = true
        },
       closePopup(state) {
            var currState = current(state);
            state.lastNoteRef = ""
            state.selectedNote = ""
            state.popupShown = false
            state.noteText = ""
            var targetBtn;
            if (currState.newPopup) {
                targetBtn = document.getElementById('Notes').focus();
            } else if (currState.selectedNote.name) {
                var SelectedNoteName = currState.selectedNote.name;
                targetBtn = document.getElementsByName(SelectedNoteName)[0].focus();
            }
        },
        closeNotes(state) {
            state.notesList = []
            state.noteFlag = false
            state.canvasObj = ""
            state.x = ""
            state.y = ''
            state.newNote = false
            state.selectedNote = ""
            state.newPopup = false
            state.popupShown = false
            state.noteText = ""
            state.notePreview = null
            state.notesupdated = false
        },
        saveNotes(state) {
            if(state.focmode) return
            var { lastNoteRef, ...data } = state
            if(state.notesupdated == true)
            {
                if(state.notesList.length>0)
                    localStorage.setItem(`notes#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`, JSON.stringify({ ...data, date: Date.now() }))
                else{
                    localStorage.removeItem(`notes#${Readium.userInfo.id}#${Readium.bookDetails.get('isbn')}#${$("#jumpToPageInput").val().split(" ").join("")}`)
                }
            state.notesupdated =false
        }
        },
        loadSaved(state, { payload }) {
            if (Date.now() - payload.date > ONDAY) {
                return
            }
            state.notesList = payload.notesList
            // state.noteFlag = payload.noteFlag
            // state.canvasObj = payload.canvasObj
            // state.selectedNote = payload.selectedNote
            // state.popupShown = payload.popupShown
            // state.noteText = payload.noteText
        },
        showNotePreview(state,{payload}){
            if(state.focmode)
                state.notePreview = payload
        }

    },
})

const { addNote, enableNote, disableNote, changeXY, showPopup, deleteNote, changeText, updateNote, closePopup, closeNotes, saveNotes, loadSaved,showNotePreview,setFOCMode } = noteSlice.actions
export { addNote, enableNote, disableNote, changeXY, showPopup, deleteNote, changeText, updateNote, closePopup, closeNotes, saveNotes, loadSaved,showNotePreview,setFOCMode, notesCleanup }
export default noteSlice.reducer